import Vue from 'vue'

// check why import axiosFactory is needed
import axiosFactory from '../../../plugins/axiosFactory'
import axios from 'axios/index'
Vue.use(axiosFactory, axios)

var resource = Vue.axiosFactory.create({baseURL: 'app/products'})

export default {
  getProductPrice (productId) {
    return resource({method: 'get', url: `/${productId}/get_price`})
  }
}
